import { get } from 'lodash'

import { ArchiveResource, TitleResource, getTranslatedString, ArchiveTypeResource, TranslatedString, ProductionResource, PermanentLocationArchiveResource, ActualContainerArchiveResource } from '@skinsoft/types';

export const cote = (archive: ArchiveResource): string | undefined | null => {
    // @ts-ignore
    return get(archive, 'identificationArchiveSchema.cote.value') ??
    get(archive, 'identificationArchiveSchema.cote')
}

export const descriptionLevel = (archive: ArchiveResource): string | undefined | null => {
    // @ts-ignore
    return get(archive, 'identificationArchiveSchema.descriptionLevel.ref') ??
    get(archive, 'identificationArchiveSchema.descriptionLevel')
}

export const titles = (archive: ArchiveResource): Array<TitleResource> | undefined | null => {
    return get(archive, 'identificationArchiveSchema.titles')
}

export const title = (archive: ArchiveResource, locale: string): string | undefined | null => {
    const archiveTitles = titles(archive)

    if(archiveTitles && archiveTitles.length) {
        if(archiveTitles[0]?.title) {
            return getTranslatedString(
                archiveTitles[0].title,
                locale
            )
        }
    }

    return undefined
}

export const firstMediaId = (archive: ArchiveResource): string | undefined | null => {
    // @ts-ignore
    return get(archive, 'associatedMedias.first.ref') ?? 
    get(archive, 'associatedMedias.first')
}

export const path = (archive: ArchiveResource): string | undefined | null => {
    // @ts-ignore
    return get(archive, 'archivePathSchema.path.value') ?? 
    get(archive, 'archivePathSchema.path')
}

export const archiveTypes = (archive: ArchiveResource): Array<ArchiveTypeResource> | undefined | null => {
    return get(archive, 'contentAndStructureArchiveSchema.archiveType')
}

export const institution = (archive: ArchiveResource): string | undefined | null => {
    return get(archive, 'institutionCreation')
}

export const principalMediumType = (archive: ArchiveResource): string | undefined | null => {
    return get(archive, 'contentAndStructureArchiveSchema.mediumTypeArchive.principalMediumType')
}

export const specificMediumTypes = (archive: ArchiveResource): string[] | null | undefined => {
    return get(archive, 'contentAndStructureArchiveSchema.mediumTypeArchive.specificMediumTypes')
}

export const materialImportance = (archive: ArchiveResource): TranslatedString | undefined | null => {
    return get(archive, 'identificationArchiveSchema.materialImportance')
}

export const productions = (archive: ArchiveResource): ProductionResource[] | null | undefined => {
    return get(archive, 'contextArchiveSchema.productions')
}

export const realTimeLocation = (archive: ArchiveResource): PermanentLocationArchiveResource | null | undefined => {
    return get(archive, 'locationArchiveSchema.realTimeLocation')
}

export const conditioningMaterial = (archive: ArchiveResource): TranslatedString | undefined | null => {
    return get(archive, 'archiveSafetyPlanSchema.conditioningMaterial')
}

export const actualContainers = (archive: ArchiveResource): ActualContainerArchiveResource[] | null | undefined => {
    return get(archive, 'conditioningArchiveSchema.actualContainer')
}

export const referentArchive = (archive: ArchiveResource): string | undefined | null => {
    return get(archive, 'linkArchiveSchema.referentArchive')
}